const testimonials = [
  {
    name: "Jennifer M.",
    location: "Lawrenceville, GA",
    rating: 5,
    text: "I had a family cruise to the Caribbean in 10 days and realized my passport had expired. I was panicking because I thought I'd have to drive all the way to Atlanta and hope for an appointment. Fast Passport Center saved me — I started online from my home in Lawrenceville, shipped from the UPS Store on River Overlook, and had my passport in 6 days. Incredible service.",
    service: "Emergency Passport",
  },
  {
    name: "Robert K.",
    location: "Snellville, GA",
    rating: 5,
    text: "I needed an emergency passport for a last-minute business trip to Toronto. Fast Passport Center made it so easy. The checklist was perfect, the document review caught a form error I would have missed, and my passport arrived in 4 days. I shipped overnight from Snellville — never had to leave my area.",
    service: "Emergency Passport",
  },
  {
    name: "Amanda T.",
    location: "Duluth, GA",
    rating: 5,
    text: "After my divorce, I needed to update my passport with my maiden name for an international work conference. I had no idea what paperwork was required. Fast Passport Center walked me through the name change process, told me exactly which court documents to include, and got my corrected passport back in 8 days. Smooth and stress-free.",
    service: "Name Change",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function LawrencevilleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Lawrenceville Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Lawrenceville, Snellville, Duluth, and Gwinnett County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}